{
    "nav__new_offer": "Nouveau devis",
    "nav__continue_as_order": "Convertir en commande",

    "footer_button__next": "Suivant",
    "footer_button__back": "Retour",
    "footer_button__save": "Enregistrer le brouillon",
    "footer_button__finalize": "Finaliser",
    "footer_button__cancel": "Annuler",
    "footer_button__view_detail": "Voir le détail de la commande",

    "stepper__step_1": "En-tête",
    "stepper__step_2": "Lignes",
    "stepper__step_3": "Vérification"
}
